package com.neurobs.util

import io.circe._
import io.circe.syntax._

import java.util.Base64

object JsonPrinter {
	val jsonPrinter = Printer.noSpaces.copy(dropNullValues = true)
	val jsonPrettyPrint = Printer.spaces2.copy(dropNullValues = true)
	val PrettyDoubleEncoder: Encoder[Double] = (a: Double) => Json.fromBigDecimal(prettyDouble(a))

	/** Prints JSON for object with no spaces, and dropping null properties
	  *
	  * @param data Object to serialize
	  * @param rds Json encoder for type A
	  * @tparam A Type of the object
	  * @return JSON string
	  */
	def jsonPrint[A](data: A)(implicit rds: io.circe.Encoder[A]): String = data.asJson.printWith(jsonPrinter)

	/** Prints JSON for object with spaces, and dropping null properties
	  *
	  * @param data Object to serialize
	  * @param rds Json encoder for type A
	  * @tparam A Type of the object
	  * @return JSON string
	  */
	def jsonPrettyPrint[A](data: A)(implicit rds: io.circe.Encoder[A]): String = data.asJson.printWith(jsonPrettyPrint)

	/** Decodes a JSON string to an object
	  *
	  * @param json JSON encoded string
	  * @param rds Circe decoder
	  * @tparam A Type of object encoded
	  * @return Some(A) or None if parsing failed
	  */
	def fromJson[A](json: String)(implicit rds: io.circe.Decoder[A]): Option[A] = {
		parser.decode[A](json) match {
			case Left(_) => None
			case Right(a) => Some(a)
		}
	}

	implicit val arrayByteEncoder: Encoder[Array[Byte]] =
		Encoder.encodeString.contramap(bytes => Base64.getEncoder.encodeToString(bytes))

	implicit val arrayByteDecoder: Decoder[Array[Byte]] =
		Decoder.decodeString.emap { s =>
			try Right(Base64.getDecoder.decode(s))
			catch {
				case _: IllegalArgumentException => Left("Invalid Base64 string for Array[Byte]")
			}
		}
}
